import React from "react";

import { Trans } from "react-i18next";
import LineItems from "components/documents/LineItems";
import HeaderData from "components/documents/HeaderData";
import CurrencyConversion from "./documents/CurrencyConversion";
import HeaderImage from "components/documents/InvoiceHeaders/HeaderImage"
import FooterImage from "components/documents/InvoiceHeaders/FooterImage"

import { useTranslation } from "react-i18next";

import { convertUTCToLocal, getStyle, LAYOUT_COMPONENTS_MAP } from "services/util";
import QRCode from 'assets/images/qr-code.png'


export const InvoicePreviewContainer = ({
    settings,
    defaultLayoutSettings,
    ...props
}) => { 
    const { t } = useTranslation();

    const organisation = {
        "Name": "Demo Company (Global)",
        "LegalName": "Demo Company (Global)",
        "BaseCurrency": "USD",
        "CountryCode": "CA",
        "TaxNumber": "101-2-303",
        "Addresses": [
            {
                "AddressType": "POBOX",
                "AddressLine1": "23 Main Street",
                "AddressLine2": "Central City",
                "City": "Marineville",
                "Region": "",
                "PostalCode": "12345",
                "Country": "",
                "AttentionTo": ""
            }
        ],
        "TaxNumberName": "Tax reg"
    }
    
    const item = {
        "Type": "ACCREC",
        "InvoiceNumber": "INV-0123",
        "Reference": "REF-5678",
        "AmountDue": 2500.0,
        "AmountPaid": 500.0,
        "CurrencyRate": 1.25,
        "IsDiscounted": true,
        "DateString": "2024-07-24",
        "Date": "2024-07-24T00:00:00.000Z",
        "DueDateString": "2024-08-01",
        "DueDate": "2024-08-01T00:00:00.000Z",
        "Status": "AUTHORISED",
        "LineAmountTypes": "Exclusive",
        "LineItems": [
            {
                "ItemCode": "SVC01",
                "Description": "Consulting services - per hour",
                "UnitAmount": 200.0,
                "TaxType": "TAX002",
                "TaxAmount": 50.0,
                "LineAmount": 200.0,
                "AccountCode": "400",
                "Item": {
                    "Name": "Consulting services",
                    "Code": "SVC01"
                },
                "Quantity": 10.0,
            }
        ],
        "SubTotal": 2000.0,
        "TotalTax": 500.0,
        "Total": 2500.0,
        "UpdatedDateUTC": "2024-07-24T11:00:00.000Z",
        "CurrencyCode": "SAR"
    };

    const contact = {
        "ContactNumber": "ctc12345",
        "Name": "John Doe",
        "FirstName": "John",
        "LastName": "Doe",
        "EmailAddress": "john.doe@example.com",
        "Addresses": [
            {
                "AddressType": "POBOX",
                "AddressLine1": "PO Box 123",
                "City": "Metropolis",
                "PostalCode": "12345"
            },
            {
                "AddressType": "STREET",
                "AddressLine1": "123 Main St",
                "City": "Metropolis",
                "PostalCode": "12345"
            }
        ],
        "id_type": "PASSPORT",
        "id_name": "Passport ID",
        "id_number": "A1234567"
    }

    const taxRates = [
        {
            "Name": "Tax on Sales",
            "TaxType": "TAX002",
            "DisplayTaxRate": 15.0,
            "EffectiveRate": 15.0,
        }
    ];

    let Header = LAYOUT_COMPONENTS_MAP[defaultLayoutSettings?.layout] || LAYOUT_COMPONENTS_MAP.default

    let baseStyle = { fontSize: (defaultLayoutSettings?.font_size || settings.font_size_base || 16) + 'px' }

    const headerLogoStyle = getStyle(defaultLayoutSettings?.header_logo_style)
    const footerLogoStyle = getStyle(defaultLayoutSettings?.footer_logo_style)
    const invoiceLogoStyle = getStyle(defaultLayoutSettings?.invoice_logo_style)
    const invoiceTitleStyle = getStyle(defaultLayoutSettings?.invoice_title_style)
    const invoiceLabelStyle = getStyle(defaultLayoutSettings?.invoice_label_style)
    const invoiceContentStyle = getStyle(defaultLayoutSettings?.invoice_content_style)
    const lineItemHeaderStyle = getStyle(defaultLayoutSettings?.line_item_header_style)
    const lineItemStyle = getStyle(defaultLayoutSettings?.line_item_style)
    const subtotalLineStyle = getStyle(defaultLayoutSettings?.subtotal_line_style)
    const taxLineStyle = getStyle(defaultLayoutSettings?.tax_line_style)
    const totalLineStyle = getStyle(defaultLayoutSettings?.total_line_style)

    if (defaultLayoutSettings) {
        if (defaultLayoutSettings?.font_family) {
            baseStyle = { ...baseStyle, fontFamily: defaultLayoutSettings?.font_family }
        }

        if (defaultLayoutSettings?.font_color) {
            baseStyle = { ...baseStyle, color: defaultLayoutSettings?.font_color }
        }

        if (footerLogoStyle) {
            if (footerLogoStyle.display !== 'none' && footerLogoStyle.height && defaultLayoutSettings.footer_logo) {
                baseStyle = { ...baseStyle, paddingBottom: footerLogoStyle.height }
            }
        }
    }

    return (
        <div id="root">
            <div className="ltr" dir="ltr">
                <div className="container-fluid my-3" style={{ ...baseStyle, position: 'relative', minHeight: "842px", }}>

                    <HeaderImage value={defaultLayoutSettings?.header_logo} invoiceLogoStyle={headerLogoStyle} />

                    <Header
                        item={item}
                        company={organisation}
                        client={contact}
                        taxRates={taxRates}
                        t={t}
                        settings={settings}
                        doc_name={settings.invoice_label || 'Tax Invoice'}
                        hideAttention={true}
                        logo={settings.logo}
                        taxed={true}
                        qrCode={QRCode}
                        defaultLayoutSettings={defaultLayoutSettings}
                        invoiceLogoStyle={invoiceLogoStyle}
                        invoiceTitleStyle={invoiceTitleStyle}
                        invoiceLabelStyle={invoiceLabelStyle}
                        invoiceContentStyle={invoiceContentStyle}
                    >
                        <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Invoice Date" value={item.DateString} />
                        <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Invoice Time" value={convertUTCToLocal(item.UpdatedDateUTC)} />
                        <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Invoice Number" value={item.InvoiceNumber} />
                        <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Reference" value={item.Reference} />
                        <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Supply Date" value={item.ExpectedPaymentDateString?.substr(0, 10)} />
                    </Header>

                    <LineItems
                        invoice={item}
                        taxRates={taxRates}
                        includeDiscount={true}
                        lang={'en'}
                        lineItemHeaderStyle={lineItemHeaderStyle}
                        lineItemStyle={lineItemStyle}
                        subtotalLineStyle={subtotalLineStyle}
                        taxLineStyle={taxLineStyle}
                        totalLineStyle={totalLineStyle}
                    />
                    <CurrencyConversion item={item} organisation={organisation} />
                    <div className="font-weight-bold mt-3 mb-2">
                        <Trans>Due Date: </Trans> {item.DueDateString}
                    </div>
                    {settings.footer ? (
                        <div style={{ whiteSpace: "pre-line" }} className="mt-1">
                            {settings.footer}
                        </div>
                    ) : null}
                    {settings.footer_english ? (
                        <div style={{ whiteSpace: "pre-line" }} className="mt-1 ltr" dir="ltr">
                            {settings.footer_english}
                        </div>
                    ) : null}
                    
                    <FooterImage value={defaultLayoutSettings?.footer_logo} invoiceLogoStyle={footerLogoStyle} />
                    
                </div>
            </div>
        </div>
    )
};

export default InvoicePreviewContainer
